// extracted by mini-css-extract-plugin
export default {"answer":"styles_answer__YwB3H","icon_holder":"styles_icon_holder__TC03n","icon":"styles_icon__L0LHI","text":"styles_text__B3a0B","selected":"styles_selected__IIhR3"};